/**
 * The agent picker list for forms: the live roster from GET /api/agents.
 * failed is set when the roster could not be loaded; reload tries again.
 */

import { useCallback, useEffect, useRef, useState } from 'react';
import { getAllAgents } from '../services/agentService';
import { buildAgentOptions, type AgentOption } from '../utils/agentOptions';

export function useAgentOptions(): { options: AgentOption[]; failed: boolean; loading: boolean; reload: () => void } {
  const [options, setOptions] = useState<AgentOption[]>([]);
  const [failed, setFailed] = useState(false);
  const [loading, setLoading] = useState(true);
  const mounted = useRef(true);

  const reload = useCallback(() => {
    setLoading(true);
    setFailed(false);
    getAllAgents()
      .then((agents) => {
        if (mounted.current) setOptions(buildAgentOptions(agents));
      })
      .catch((err: unknown) => {
        console.error('[useAgentOptions] could not load the agent roster', err);
        if (mounted.current) setFailed(true);
      })
      .finally(() => {
        if (mounted.current) setLoading(false);
      });
  }, []);

  useEffect(() => {
    mounted.current = true;
    reload();
    return () => {
      mounted.current = false;
    };
  }, [reload]);

  return { options, failed, loading, reload };
}
